const toNumber = (value) => {
  const number = Number(value ?? 0);
  return Number.isFinite(number) ? number : 0;
};

/**
 * Returns the amount used by sales screens and reports.
 * A linked SO applies only to the weight stored in soUsedWeight;
 * any remaining weight uses the regular sale price.
 */
export const getSaleItemSummary = (item) => {
  const destinationEntries = Array.isArray(item?.destinationEntries)
    ? item.destinationEntries.filter((entry) => entry)
    : [];

  if (destinationEntries.length > 0) {
    const weight = destinationEntries.reduce(
      (sum, entry) => sum + Math.max(0, toNumber(entry.weight)),
      0,
    );
    const amount = destinationEntries.reduce(
      (sum, entry) =>
        sum +
        Math.max(0, toNumber(entry.weight)) *
          toNumber(entry.pricePerUnit),
      0,
    );
    return {
      weight,
      pricePerUnit: weight > 0 ? amount / weight : 0,
      amount,
      soUsedWeight: 0,
      extraWeight: 0,
    };
  }

  const weight = Math.max(0, toNumber(item?.netWeight ?? item?.weight));
  const soUsedWeight = Math.min(
    weight,
    Math.max(0, toNumber(item?.soUsedWeight)),
  );
  const soPricePerUnit = Math.max(0, toNumber(item?.soPricePerUnit));
  const regularPricePerUnit = toNumber(item?.pricePerUnit);
  const hasSO = soUsedWeight > 0 && soPricePerUnit > 0;
  const calculatedAmount = hasSO
    ? soUsedWeight * soPricePerUnit +
      (weight - soUsedWeight) * regularPricePerUnit
    : weight * regularPricePerUnit;
  const storedAmount = toNumber(item?.netPrice);
  const amount = hasSO || storedAmount <= 0 ? calculatedAmount : storedAmount;

  return {
    weight,
    pricePerUnit: weight > 0 ? amount / weight : regularPricePerUnit,
    amount,
    soUsedWeight,
    extraWeight: Math.max(0, weight - soUsedWeight),
  };
};

